import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import config from "../config";
import { storage } from "../utils/storage";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import errorIcon from "../assets/images/error-icon.svg";

const Login = ({ loginStatus }) => {
  const [username, setUserID] = useState("");
  const [password, setPassword] = useState("");

  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [toggleforgotpassword, setToggleforgotpassword] = useState(false);
  const [otpsection, setotpsection] = useState(false);
  const [newpasswordsection, setNewpasswordsection] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [forgotemail, setForgotemail] = useState("");
  const [maskedemail, setMaskedemail] = useState("");
  const [otp, setOtp] = useState("");
  const [resettoken, setResettoken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const history = useHistory();
  // console.log("hy");

  /**
   * Check if the access_token already exist in localstorage
   */
  useEffect(() => {
    if (storage.getItem("access_token")) {
      history.push("/");
    }
  }, [history]);

  // useEffect(() => {
  //   window.location.reload();
  // }, [history]);

  /**
   * Perform login
   *
   * After success login store all the user attributes in localstorage for future use
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    var login_info = { username, password };
    setIsPending(true);
    fetch(`${config.API_BASE_URL}/api/access_control/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login_info),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error("Authentication Fail");
        }
      })
      .then((data) => {
        setIsPending(false);

        storage.setItem("rememberMe", rememberMe, rememberMe);

        Object.keys(data).forEach((key) => {
          storage.setItem(key, data[key], rememberMe);
        });

        window.location.reload();
      })
      .catch((err) => {
        setIsPending(false);
        setError(err.message);
      });
  };

  const handelOTP = async () => {
    setIsPending(true);
    setError(null);

    if (!forgotemail) {
      setError("Please enter your User ID or Email");
      setIsPending(false);
      return;
    }

    try {
      const res = await fetch(
        `${config.API_BASE_URL}/api/access_control/forgot_password/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: forgotemail }),
        }
      );

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || "Failed to send OTP. Try again.");
      }

      const data = await res.json();

      setIsPending(false);
      setMaskedemail(data.masked_email);
      setotpsection(true);
      NotificationManager.success(
        "OTP Sent",
        `OTP has been sent to ${data.masked_email}`,
        5000
      );

      console.log(data);
    } catch (err) {
      setIsPending(false);
      setError(err.message || "Failed to send OTP. Try again");
      setotpsection(false);

      NotificationManager.error(
        "Error",
        err.message || "Failed to send OTP",
        5000
      );
    }
  };

  const enterOTP = async (e) => {
    // console.log("getting inside the function");
    setIsPending(true);
    setError(null);
    if (!otp) {
      setError("Please enter the OTP");
      setIsPending(false);
      return;
    }
    const res = await fetch(
      `${config.API_BASE_URL}/api/access_control/forgot_password/verify_otp/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotemail, otp: otp }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error("Failed to verify OTP. Try again");
        }
      })
      .then((data) => {
        setIsPending(false);
        setResettoken(data.reset_token);
        setNewpasswordsection(true);
        NotificationManager.success(
          "OTP verified",
          `OTP has been verified for ${forgotemail}`,
          5000
        );
        // console.log(data);
      })
      .catch((err) => {
        // console.log(err);
        setIsPending(false);
        setError(err.message);
        NotificationManager.error(
          "Error",
          "Failed to verify OTP. Try again",
          5000
        );
        setNewpasswordsection(false);
      });
  };

  const handleNewPassword = async () => {
    if (!newPassword) {
      setError("Please enter your new password");
      return;
    }
    if (!confirmPassword) {
      setError("Please confirm your new password");
      return;
    }
    if (newPassword !== confirmPassword) {
      NotificationManager.error("Error", "Passwords do not match", 5000);
      setError("Passwords do not match");
      return;
    }
    setError("");
    setIsPending(true);
    setIsPending(true);
    setError(null);

    const res = await fetch(
      `${config.API_BASE_URL}/api/access_control/forgot_password/reset_password/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          reset_token: resettoken,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error("Failed to reset password");
        }
      })
      .then((data) => {
        setIsPending(false);
        NotificationManager.success(
          "Password Reset",
          `Password has been successfully reset for ${forgotemail}`,
          5000
        );
        setToggleforgotpassword(false);
        // console.log(data);
      })
      .catch((err) => {
        // console.log(err);
        setIsPending(false);
        NotificationManager.error(
          "Error",
          "Failed to reset password Try again",
          5000
        );
      });
  };

  return (
    <div className="body-login">
      <NotificationContainer />
      <div className="login">
        <div className="login-inner-main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4">
                <div className="login-left">
                  <div className="login-inner">
                    <div className="form-logo">
                      <img src="assets/images/logo.png" alt="" />
                    </div>
                    {!toggleforgotpassword ? (
                      <form onSubmit={handleSubmit}>
                        <div className="from-class">
                          <label>User ID</label>
                          <input
                            type="text"
                            placeholder="Enter Your User Id"
                            required
                            value={username}
                            onChange={(e) => {
                              setUserID(e.target.value);
                            }}
                          />
                        </div>
                        <div className="from-class">
                          <label>Password</label>
                          <input
                            type="password"
                            placeholder="Enter Your Password"
                            required
                            value={password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                          />
                        </div>
                        <div className="from-class">
                          <label className="checkbox-container">
                            Remember Me
                            <input
                              type="checkbox"
                              checked={rememberMe}
                              onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className="from-class">
                          {error && <p>{error}</p>}
                        </div>
                        <div className="from-class">
                          {!isPending && <input type="submit" value="Login" />}
                          {isPending && (
                            <input type="submit" disabled value="Checking..." />
                          )}
                        </div>
                      </form>
                    ) : !otpsection ? (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handelOTP();
                        }}
                      >
                        <div className="from-class">
                          <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Find your DATA
                            <span style={{ color: "#F05A27" }}>KLOUT</span>{" "}
                            account <br />
                          </p>
                          <label>Enter User ID / Email</label>
                          <input
                            type="text"
                            placeholder="Enter Your User ID / Email"
                            // required
                            value={forgotemail}
                            onChange={(e) => {
                              setForgotemail(e.target.value);
                              setError("");
                            }}
                          />
                        </div>
                        {error && (
                          <div className="from-class">
                            <p
                              className="text-red-600"
                              style={{ padding: "0px", fontSize: "13px" }}
                            >
                              {error}
                            </p>
                          </div>
                        )}
                        <div className="from-class">
                          {!isPending && (
                            <input type="submit" value="Send OTP" />
                          )}
                          {isPending && (
                            <input type="submit" disabled value="Checking..." />
                          )}
                        </div>
                      </form>
                    ) : !newpasswordsection ? (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          enterOTP();
                        }}
                      >
                        <div className="from-class">
                          <p>
                            You OTP has been sent to your registered email
                            address {maskedemail} . Please enter the OTP to
                            proceed.
                          </p>
                          <label>Enter OTP </label>
                          <input
                            type="text"
                            placeholder="Enter Your OTP"
                            // required
                            value={otp}
                            onChange={(e) => {
                              setOtp(e.target.value);
                              setError("");
                            }}
                          />
                        </div>
                        {error && (
                          <div className="from-class">
                            <p
                              className="text-red-600"
                              style={{ padding: "0px", fontSize: "13px" }}
                            >
                              {error}
                            </p>
                          </div>
                        )}
                        <div className="from-class">
                          {!isPending && <input type="submit" value="Next" />}
                          {isPending && (
                            <input type="submit" disabled value="Checking..." />
                          )}
                        </div>
                      </form>
                    ) : (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleNewPassword();
                        }}
                        className="mt-2"
                      >
                        <div className="from-class flex flex-col gap-4">
                          <label htmlFor="newPassword">
                            Enter New Password
                          </label>
                          <span className="flex gap-1 flex-row">
                            <input
                              type="password"
                              id="newPassword"
                              placeholder="Enter Your New Password"
                              value={newPassword}
                              onChange={(e) => {
                                setNewPassword(e.target.value);
                                setError("");
                              }}
                              style={{ borderColor: error ? "red" : "" }}
                            />
                            {/* {error && <img src={errorIcon} alt="error-icon" />} */}
                          </span>
                          <label htmlFor="confirmPassword">
                            Confirm New Password
                          </label>
                          <span className="flex gap-1 flex-row">
                            <input
                              type="password"
                              id="confirmPassword"
                              placeholder="Confirm Your New Password"
                              value={confirmPassword}
                              onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                setError("");
                              }}
                              style={{ borderColor: error ? "red" : "" }}
                            />
                            {/* {error && <img src={errorIcon} alt="error-icon" />} */}
                          </span>
                          {error && (
                            <p
                              className="text-red-600"
                              style={{ fontSize: "14px", padding: "0px" }}
                            >
                              {error}
                            </p>
                          )}
                        </div>
                        <div className="from-class mt-4">
                          {!isPending && (
                            <input type="submit" value="Reset Password" />
                          )}
                          {isPending && (
                            <input type="submit" disabled value="Checking..." />
                          )}
                        </div>
                      </form>
                    )}

                    <p>
                      {toggleforgotpassword ? (
                        <span
                          style={{ color: "#1BD7EE" }}
                          onClick={() => {
                            setToggleforgotpassword(false);
                            setNewpasswordsection(false);
                            setotpsection(false);
                            setForgotemail("");
                            setOtp("");
                            setMaskedemail("");
                            setResettoken("");
                            setNewPassword("");
                            setConfirmPassword("");
                            setError("");
                          }}
                          className=" cursor-pointer"
                        >
                          Sign In
                        </span>
                      ) : (
                        <>
                          <span>Forgot Password? </span>
                          <span
                            style={{ color: "#1BD7EE" }}
                            onClick={() => setToggleforgotpassword(true)}
                            className=" cursor-pointer"
                          >
                            Click Here.
                          </span>{" "}
                        </>
                      )}
                      <br /> OR <br />
                      <a href="#">Use Custom Domain</a>
                    </p>
                    {/* <h4>
                      Not A Customer Yet? <a href="#">Try For Free</a>
                    </h4> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-md-offset-1">
                <div className="hello-bg">
                  <h2>
                    Enter Details to Start <span>Trial</span> Now!
                  </h2>
                  <p>No Hidden Charges, No Credit Card.</p>
                  <ul>
                    <li>Upload Your Own Data Or Use the Pre-loaded </li>
                    <li>Cloud Based SAAS</li>
                    <li>Preconfigured Workflow, Reports & Dashboards</li>
                    <li>Preconfigured Based On User Profile</li>
                  </ul>
                  <div className="login-bttn">
                    <a href="#">START MY TRIAL</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
